import {
  get,
  post,
  getPYWBackend,
  deletePYWBackend,
  postPYWBackend,
  postAuthorizedFargate,
} from 'utils/apiHelper'
import { getCookieIDFromLocalStorage, getCookieExpireFromLocalStorage } from 'utils/helperFunctions'

const getAuthHeaders = (hashedPin) => {
  const sessionId = getCookieIDFromLocalStorage(hashedPin)
  const sessionExpire = getCookieExpireFromLocalStorage(hashedPin)
  if (!sessionId) return {}
  return {
    'session-id': sessionId,
    'session-expire': new Date(sessionExpire * 1000).toISOString(),
  }
}

export const getShippingInfo = (hashedPin, lang) =>
  get({
    path: `/progress/${hashedPin}/${lang}`,
    config: { headers: getAuthHeaders(hashedPin) },
  })

export const getDeliveryDateInfo = (shipmentPin) =>
  post({ path: `/deliverydate`, body: { shipmentPin } })

export const getPhotoPODImages = (shipmentPin) =>
  get({
    path: `/getPhoto/${shipmentPin}`,
  })

export const setDeliveryPreferences = (
  type,
  lan,
  id,
  instructions,
  buzzerCode,
  dropOffLocation,
  signature,
  prevSignature,
  hashedPin
) =>
  post({
    path: `/setDeliverypreference`,
    body: {
      additional_delivery_instructions: instructions,
      buzzer_code: buzzerCode,
      delivery_preference: dropOffLocation,
      lang: lan,
      preference_modified: type,
      remote_signature_preference: signature,
      previous_signature_preference: prevSignature,
      shipmentId: id,
    },
    config: {
      headers: getAuthHeaders(hashedPin),
    },
  })

export const verifyPostalCode = (shipmentId, postalCode, locale) =>
  post({ path: `/verifyPostalCode/${shipmentId}/${postalCode}/${locale}` })

export const verifyVerificationCode = (shipmentId, verificationCode, locale) =>
  post({ path: `/verifyVerificationCode/${shipmentId}/${verificationCode}/${locale}` })

export const resendVerificationCode = (shipmentId, locale) =>
  post({ path: `/resendSavePreferencesverificationCode/${shipmentId}/${locale}` })

export const updateSession = (shipmentId, hashedPin) =>
  post({
    path: `/updateSession/${shipmentId}`,
    config: {
      headers: getAuthHeaders(hashedPin),
    },
  })

export const deleteSession = (shipmentId, hashedPin) =>
  post({
    path: `/deleteSession/${shipmentId}`,
    config: {
      headers: getAuthHeaders(hashedPin),
    },
  })

export const updateOptInSMSFlag = (shipmentId, optInFlagSMS) =>
  post({ path: `/updateSMSFlag/${shipmentId}/${optInFlagSMS}` })

export const isSubscribed = async (phonenumber) => get({ path: `/isSubscribed/${phonenumber}` })
export const sendOTPForUser = (phonenumber, lang) =>
  post({
    path: `/sendOTPForUser/${phonenumber}/${lang}`,
  })

export const resendOTPForUser = (phonenumber, lang) =>
  post({
    path: `/resendOTPForUser/${phonenumber}/${lang}`,
  })

export const resendOTPForNewUser = (phonenumber, lang) =>
  post({
    path: `/resendOTPForNewUser/${phonenumber}/${lang}`,
  })

export const verifyOTP = (phonenumber, lang, otp) =>
  post({
    path: `/verifyOTP/${phonenumber}/${lang}/${otp}`,
  })

export const verifyOTPForEmail = async (otp, phoneNumber, lang) =>
  post({
    path: `/verifyOTPGetEmail/${phoneNumber}/${otp}/${lang}`,
  })

export const verifyOTPWithEmail = (phonenumber, lang, otp, prn, email, userId, oldUserId) => {
  const body = {
    email,
    otp,
    phonenumber,
    lang,
    userId,
    ...(oldUserId && { oldUserId }),
  }
  return post({
    path: `/verifyOTPWithEmail/${phonenumber}/${lang}/${otp}`,
    body,
  })
}

export const sendEmailVerification = (body) =>
  post({
    path: `/sendEmailVerification`,
    body,
  })

export const subscribe = (body) =>
  post({
    path: `/subscribeToPYW`,
    body,
  })

export const phoneUpdateSendOTP = (phoneNumber, lang) =>
  postAuthorizedFargate({
    path: `/phoneUpdateSendOTPCall/${phoneNumber}/${lang}`,
  })

export const phoneUpdateVerifyOTP = (phoneNumber, otp, lang) =>
  postAuthorizedFargate({
    path: `/phoneUpdateVerifyOTPCall/${phoneNumber}/${otp}/${lang}`,
  })

export const getOptedInStatus = (shipmentId, shipmentPin, hashedPin, phoneNumber, prn) =>
  getPYWBackend({
    path: `/email-notification/api/email-verification/status?shipmentId=${shipmentId}&shipmentPin=${shipmentPin}&hashedPin=${hashedPin}&phoneNumber=${phoneNumber}`,
    config: {
      headers: {
        prn,
      },
    },
  })

export const unsubscribe = (shipmentId, shipmentPin, hashedPin, phoneNumber) =>
  deletePYWBackend({
    path: `/email-notification/api/email-verification/unsubscribe?shipmentId=${shipmentId}&shipmentPin=${shipmentPin}&hashedPin=${hashedPin}&phoneNumber=${phoneNumber}`,
  })

export const resendVerificationLink = (body) =>
  postPYWBackend({
    path: `/email-notification/api/email-verification/resend`,
    body,
  })

export const unsubscribeByToken = (unsubscribeToken) =>
  deletePYWBackend({
    path: `/email-notification/api/email-verification/token-unsubscribe?unsubscribeToken=${unsubscribeToken}`,
  })

export const checkSession = () =>
  getPYWBackend({
    path: '/email-notification/api/recipient/verify-session',
    config: { withCredentials: true },
  })

// Different types of email requests
export const sendVerificationEmail = (emailAddress, language, shipmentPin, hashedPin) =>
  postPYWBackend({
    path: '/email-notification/api/email-verification/request',
    body: { emailAddress, shipmentPin, shipmentHashedPin: hashedPin, language },
  })

export const sendRecipientRegisterEmail = (emailAddress, language, type, userId, oldUserId) =>
  postPYWBackend({
    path: '/email-notification/api/recipient/register-email-request',
    body: { emailAddress, language, type, userId, oldUserId },
  })

export const sendRecipientLoginEmail = (emailAddress, language) =>
  postPYWBackend({
    path: '/email-notification/api/recipient/login-email-request',
    body: { emailAddress, language },
  })

// Different types of email verifications
export const verifyShipmentByToken = (token) =>
  postPYWBackend({ path: `/email-notification/api/email-verification/verify`, body: { token } })

export const verifiyLoginByToken = (token) =>
  postPYWBackend({ path: `/email-notification/api/recipient/generate-session`, body: { token } })

export const verifyRegisterNewByToken = (token) =>
  postPYWBackend({
    path: `/email-notification/api/recipient/register-create-email-verify`,
    body: { token },
  })

export const verifyRegisterUpdateByToken = (token) =>
  postPYWBackend({
    path: `/email-notification/api/recipient/register-update-email-verify`,
    body: { token },
  })

export const checkInitialSession = () =>
  getPYWBackend({
    path: '/email-notification/api/recipient/verify-session',
    config: { withCredentials: true },
  })

export const verifyRecipientSession = (shipmentId, locale) =>
  postAuthorizedFargate({
    path: `/verifyRecipientSession/${shipmentId}/${locale}`,
  })

export const getShipments = ({
  limit = process.env.REACT_APP_PAGINATION_LIMIT,
  offset = 0,
  status = 'All',
}) =>
  getPYWBackend({
    path: `/email-notification/api/recipient/get-shipments?limit=${limit}&offset=${offset}&status=${encodeURIComponent(
      status
    )}`,
    config: { withCredentials: true },
  })

export const verifyProfileUpdateByToken = (token) =>
  postPYWBackend({
    path: `/email-notification/api/recipient/update-profile-email-verify`,
    body: { token },
  })
